import React from 'react';
import { Trans } from '@lingui/macro';

import Card from '@rover/components/src/cards/Card';
import { SERVICE_TYPE_ICONS } from '@rover/components/src/formFields/ServiceTypeFilter/ServiceTypeFilter';
import { SERVICE_TYPE_CHOICES } from '@rover/constants/src/translations/service.constants';
import Boarding from '@rover/icons/svg/boarding.svg';
import { Flex, Heading, Text } from '@rover/kibble/core';
import useTheme from '@rover/kibble/themes/useTheme';

import ServiceTypeDescription from '../../ServiceTypeDescription';

export type Props = {
  services?: ServiceTypeDescription[];
};

const RebookingSearch = ({ services = [] }: Props): JSX.Element => {
  const { borderWidth, colors, background, textColor } = useTheme();
  const filteredServices = services.filter((s) => s.slug !== SERVICE_TYPE_CHOICES.training);

  return (
    <Card marginLeft="1x" display="flex" flexDirection="column">
      <Heading size="300">
        <Trans>Search for a sitter</Trans>
      </Heading>
      <Flex flexGrow="1" justifyContent="space-between" flexDirection="column">
        {filteredServices.map((service, index) => {
          const IconService = SERVICE_TYPE_ICONS[service.slug] || Boarding;
          const name = ServiceTypeDescription.NAMES()[service.slug];
          return (
            name && (
              <Flex
                key={service.slug}
                borderRadius="5px"
                border={`${borderWidth.primary} solid ${colors.border.primary}`}
                alignItems="center"
                paddingY="2x"
                paddingX="4x"
                webAs="a"
                webAsProps={{
                  href: service.webAction,
                }}
                sx={{
                  '&:hover': {
                    backgroundColor: background.secondary,
                  },
                  '&:focus, &:visited, &:hover': {
                    textDecoration: 'none !important',
                  },
                }}
                mb={index !== filteredServices.length ? '3x' : undefined}
                flexGrow="1"
              >
                <IconService width="20px" fill={textColor.secondary} />
                <Text size="100" ml="4x" fontWeight="regular" textColor="secondary">
                  {name}
                </Text>
              </Flex>
            )
          );
        })}
      </Flex>
    </Card>
  );
};

export default RebookingSearch;
